import '../Fields.module.less';
/**
 *
 * @deprecated all new forms should use HVUI/FormikForm and HVUI/FormControl
 */
const HiddenField = props => {
    const {
        input: { name, value }
    } = props;
    return <input id={name} name={name} type="hidden" value={value} />;
};

export default HiddenField;
